import e from"react";import r from"../../../external/classnames/index.js";const s=s=>{const{value:a,max:o}=s,t=r({progressbar:!0,"progressbar--completed":a===o});return e.createElement("progress",{className:t,max:o,value:a})};export{s as ProgressBar};
//# sourceMappingURL=ProgressBar.js.map
